import React, { useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
//#region types
import { TranslationKeys } from "translations";
import { FormHandles } from "models/propTypes/genericFormProps";
//#endregion
//#region components
import {
  FormValidity,
  PageLayouts,
  RouteBreadCrumb,
  SimpleEntityTitle,
  WizardContextProvider,
  useNavigationHistory,
} from "components/common";
import useCloseConfirmation from "components/common/dialogs/useCloseConfirmation";
import CreateTimeReportingProjectFooter from "./createFooter";
//#endregion
import { useTimeReportingProjectService } from "serviceHooks";
import { LocalizationHelperInstance, UrlHelper } from "utils/helpers";
import TimeReportingProjectFormNavWrapper from "./TimeReportingProjectFormNavWrapper";

const CreateTimeReportingProject: React.FC = (props) => {
  const timeReportingProjectService = useTimeReportingProjectService();
  const location = useLocation();
  const navigate = useNavigate();

  const [selectedTimeReportingProjectName, setSelectedTimeReportingProjectName] = useState<string>();

  const formRef = useRef<FormHandles>(null);

  const { goBack } = useNavigationHistory();
  const { showConfirmation } = useCloseConfirmation();

  const isFormDirty = () => {
    if (formRef.current?.isDirty) return formRef.current.isDirty();
    const touched = formRef.current?.getTouched && formRef.current.getTouched();
    return !!touched && Object.keys(touched).length > 0;
  };

  const handleCloseRequest = () => {
    if (isFormDirty()) {
      showConfirmation(async () => goBack());
    } else {
      goBack();
    }
  };

  const currentTimeReportingProjectName = () => {
    return selectedTimeReportingProjectName
      ? selectedTimeReportingProjectName
      : LocalizationHelperInstance.getFormattedMessage(TranslationKeys.TimeReportingProject.NewTimeReportingProject);
  };

  const onSubmit = () => {
    return (formRef.current && formRef.current.submit()) || new Promise<void>((resolve) => resolve());
  };

  const onFormSubmitSuccess = () => {
    navigate(UrlHelper.formatPath("/Reports/Projects"), { state: { background: location }, replace: true });
  };

  return (
    <PageLayouts.EntityFullScreen
      id={0}
      entityKey={`timeReportingProject`}
      navigation={<RouteBreadCrumb current={currentTimeReportingProjectName()} />}
      hasPermissions={timeReportingProjectService.hasEditPermissions()}
      hideSpeedDial
      closeDialog={handleCloseRequest}
      confirmCloseOnX
    >
      <WizardContextProvider>
        <FormValidity
          render={(isValid, onValidityChange) => (
            <PageLayouts.EntityCreationLayout
              className={"projectCreationWizard"}
              upperLeftComponent={<SimpleEntityTitle title={currentTimeReportingProjectName()} />}
              upperRightComponent={<></>}
              footer={
                <CreateTimeReportingProjectFooter
                  submitForm={onSubmit}
                  onSubmitSuccess={onFormSubmitSuccess}
                  isFormValid={isValid}
                />
              }
            >
              <TimeReportingProjectFormNavWrapper
                ref={formRef}
                selectedTimeReportingProjectChangeHandler={setSelectedTimeReportingProjectName}
                selectedTimeReportingProjectName={selectedTimeReportingProjectName ?? ""}
                onFormValidationChange={onValidityChange}
              />
            </PageLayouts.EntityCreationLayout>
          )}
        />
      </WizardContextProvider>
    </PageLayouts.EntityFullScreen>
  );
};

export default CreateTimeReportingProject;
